/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Sentinel Notification Icon component.
 */
export const SentinelNotificationIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.5723 9V12.9771L14.3237 14.9914' stroke={iconColor} strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
      <circle cx='12' cy='12' r='9' stroke={iconColor} strokeWidth='2' />
    </svg>
  );
};
